// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store'; // Import the Vuex store
import LandingPage from '@/pages/LandingPage.vue';
import LoginPage from '@/pages/LoginPage.vue';
import SignUpPage from '@/pages/SignUpPage.vue';
import DashboardPage from '@/pages/DashboardPage.vue';
import DataPage from '@/pages/DataPage.vue';
import ConnectionsPage from '@/pages/ConnectionsPage.vue';
import EmailPage from '@/pages/EmailPage.vue';
const routes = [
  { path: '/', component: LandingPage },
  { 
    path: '/login', 
    component: LoginPage,
    props: route => ({ token: route.query.token })  // Pass token as a prop to LoginPage
  },
  { path: '/signup', component: SignUpPage },
  { 
    path: '/dashboard', 
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  { 
    path: '/data', 
    component: DataPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/connections', 
    component: ConnectionsPage,
    meta: { requiresAuth: true },
  },
  {
    path: '/email', 
    component: EmailPage,
    meta: { requiresAuth: true },
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];

  console.log(`Routing to: ${to.path}, Authenticated: ${isAuthenticated}`); // Debug log

  if (to.meta.requiresAuth && !isAuthenticated) {
    console.warn('User not authenticated. Redirecting to login.');
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    console.warn('User already logged in. Redirecting to dashboard.');
    next('/dashboard');
  } else {
    next(); // Proceed to route
  }
});


export default router;
